export const POST_USER = "POST_USER"
export const POST_LOGIN = "POST_LOGIN"
export const POST_DECK = "POST_DECK"
export const POST_CARD = "POST_CARD"
export const DELETE_DECK = "DELETE_DECK"
export const DELETE_CARD = "DELETE_CARD"
export const PATCH_DECK_COMPLETED = "PATCH_DECK_COMPLETED"
export const PATCH_CARD = "PATCH_CARD"
export const GET_USER = "GET_USER"
export const REMOVE_USER = "REMOVE_USER"
export const GET_DECKS = "GET_DECKS"